module.exports = __webpack_public_path__ + "static/img/xiaojia.dd6b886f.png";